<template>
    <!--页面-->
    <el-container class="i-body">

      <el-aside class="i-side" width="270px">

        <aside-tab class="" border :tabs="['Container List', 'Device List']" v-model="currnetTab"></aside-tab>
        <aside-list :datas="containers" @click="rowClick" title="Container List" v-show="currnetTab==0"></aside-list>
        <aside-list :datas="tableData" title="Device List" v-show="currnetTab==1"></aside-list>

        <!--类型列表-->
        <el-row type="flex" class="typeline" v-if="false">
          <el-col :span="4" style="color: rgb(32, 160, 255)" :class="{active: currentStateCode==100}" @click.native="currentStateCode=100">{{$t('aside.type[0]')}}</el-col>
          <el-col :span="4" style="color: rgb(19, 206, 102)" :class="{active: currentStateCode==1}" @click.native="currentStateCode=1">{{$t('aside.type[1]')}}</el-col>
          <el-col :span="4" style="color: rgb(153, 169, 191)" :class="{active: currentStateCode==0}" @click.native="currentStateCode=0">{{$t('aside.type[2]')}}</el-col>
          <el-col :span="4" style="color: rgb(255, 73, 73)" :class="{active: currentStateCode==10}" @click.native="currentStateCode=10">{{$t('aside.type[3]')}}</el-col>
          <el-col :span="4" style="color: rgb(247, 186, 42)" :class="{active: currentStateCode==66}" @click.native="currentStateCode=66">{{$t('aside.type[4]')}}</el-col>
        </el-row>

      </el-aside>

      <el-container class="">
        <el-main class="i-main">
          <split-pane @resize="resize" :min-percent="10" :default-percent="currentItem.name ? 50 : 100" split="vertical">
            <div slot="paneL" class="i-pane-wrapper">
              <div class="i-pane i-pane-map" ref="imap"></div>
              <div class="i-pane i-pane-alarm elevation-10" :style="alarmPanel">
                <div class="i-pane-alarm-btn" @click="alarmTabShow = !alarmTabShow">
                  <i class="el-icon-arrow-down" v-if="!alarmTabShow"></i>
                  <i class="el-icon-arrow-up" v-if="alarmTabShow"></i>
                </div>
                <alarm></alarm>
              </div>
            </div>
            <template slot="paneR">
              <div class="i-pane chart">
                <charts :datas="currentItem" v-if="currentItem.name"></charts>
              </div>
            </template>
          </split-pane>
        </el-main>
        <!-- <el-footer class="i-footer" height="40px"></el-footer> -->
      </el-container>

      <map-tool-config :show="mapConfigVisible" v-model="mapConfig"></map-tool-config>
    </el-container>

</template>

<script>
import {getBattery} from './others'
import {getToken} from '@/common/auth'
import tree from '@/components/tree'
import mapToolConfig from '@/components/map-tool-config'
import {remoteLoad,findFromArray} from '@/common/utils'
import Charts from './charts'
import {mapMutations,mapGetters} from 'vuex'
import {GooglePanel, GetWrapper} from './maps/google-map.js'
import AsideList from './aside-list'
import AsideTab from './aside-tab'
import Alarm from './alarm/alarm'
const ACTIVATED = 'Activated'
const CONNECTED = 'Connected'
const ATTACHED = 'Attached'

export default {
  name: 'home',
  data() {
    return {
      containers: [],
      tableData: [],
      mapConfigVisible: false,
      mapConfig: {},
      currentStateCode: 100,
      currentSelectKey: ['1', '2', '3'],
      onMapData: [],
      currentItem: {},
      currnetTab: 0,

      alarmTabShow: true
    }
  },
  computed: {
    ...mapGetters([
      'userId',
      'clickedObjectId'
    ]),
    alarmPanel() {
      return {
        transform: this.alarmTabShow ? 'translateY(100%)' : 'translateY(0)'
      }
    }
  },
  watch: {
    currentStateCode() {
      this.fetchData()
    },
    currentSelectKey() {
      this.fetchData()
    }
  },
  methods: {
    ...mapMutations({
      setClickedObjectId:'SET_CLICKED_OBJECT_ID'
    }),
    rowClick(item) {
      if (item.id == this.currentItem.id) {
        return
      }

      this.currentItem = item
      this.openMarkerWindow(findFromArray(this.markers, marker => {
        marker.getTitle() == item.name
      }), item)
    },
    fetchData() {
      this.tableData = this.filterList(this.alldata)
      this.containers = this.filterList(this.allcontainers)
    },
    filterList(datas) {
      return datas.filter(item => {
        if (this.currentSelectKey.indexOf('1') != -1) {
          if (this.currentStateCode == 100 || item.stateCode.indexOf(this.currentStateCode) != -1) {
            return true
          } else {
            return false
          }
        } else {
          if (this.currentSelectKey.indexOf(item.holdId) != -1 && (item.stateCode.indexOf(this.currentStateCode) != -1 || this.currentStateCode == 100)) {
            return true
          } else {
            return false
          }
        }
      })
    },
    checkChange(nodes) {
      this.currentSelectKey = nodes.slice()
    },
    resize() {

    },
    initMap() {
      this.$nextTick(() => {
        let map = new google.maps.Map(this.$refs.imap, {
            center: {lat: 33.061798, lng: 110.442263},
            zoom: 4
        })
        this.map = map
        this.Wrapper = GetWrapper(google)
        this.setAllMarkers()
      })
    },
    setAllMarkers() {
      const Wrapper = this.Wrapper
      let markers = this.containers.map((item, i) => {
        let data = item
        let path = null
        if (item.attachState == ACTIVATED) {
          path = this.marker_red
        } else if (item.attachState == CONNECTED) {
          path = this.marker_orange
        } else {
          path = this.marker_green
        }

        const marker = new google.maps.Marker({
          icon: {
            url: path,
            labelOrigin: new google.maps.Point(20, 45)
          },
          position: { lat: parseFloat(item.lat), lng: parseFloat(item.lng) },
          // label: {
          //   text: item.name,
          //   color: '#606266',
          //   fontWeight: '600',
          //   fontSize: '12px'
          // },
          title: item.name,
          map: this.map
        })

        marker.addListener('click', () => {
          this.markerClick(marker, data)
        })

        return marker
      })

      // this.alldata.forEach(item => {
      //   const wrapper = new Wrapper(this.map, new google.maps.LatLng(item.lat, item.lng), { el: item.name, offsetY: 16 })
      //   markers.push(wrapper)
      // })

      this.markers = markers

      // var markerCluster = new MarkerClusterer(this.map, markers,
      //   {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'}
      // );
    },

    markerClick(marker, item) {
      this.rowClick(item)
    },

    openMarkerWindow(marker, item) {
      const colors = {
        Activated: '#F44336',
        Connected: '#FF9800',
        Attached: '#4CAF50'
      }
      const more = this.userId != '1' ? [] : [
        {title: 'SIM ICCID：', text: '898607B5231770404947'},
        {title: 'SIM IMSI：', text: '53S43T3A324A3'},
        {title: 'Module SN：', text: 'B7231770'},
        {title: 'G Sensor：', text: item.gsensor}
      ]
      const panel = this.$dataPanel.create({
        bgColor: true,
        title: `${item.name}`,
        attachState: `(${item.attachState})`,
        signal: item.cellidSignal,
        battery: item.battery,
        datas: [
          {title: 'Device SN：', text: 'E25E52SA6SS'},
          {title: 'Lng：', text: item.lng},
          {title: 'Lat：', text: item.lat}
        ],
        more,
        titleBackground: colors[item.attachState],
        close: true,
        onClose: () => {
          this.wrapperWindow.close()
        }
      })
      const Wrapper = this.Wrapper
      if (this.wrapperWindow) {
        this.wrapperWindow.setContent(panel)
        this.wrapperWindow.setPosition(new google.maps.LatLng(item.lat, item.lng))
      } else {
        this.wrapperWindow = new Wrapper(this.map, new google.maps.LatLng(item.lat, item.lng), { el: panel, offsetY: -70 })
      }
    }
  },
  async created() {
    if (window.google) {
      //this.initMap()
      // console.log('google 终于存在')
    } else {
      // await remoteLoad('https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js').catch(err => {
      //   this.$message.error('Network Error')
      // })
      // console.log('created start.')
      const promise = remoteLoad('https://maps.googleapis.com/maps/api/js?key=AIzaSyC2zoDmBYTkN5UtzI069ifi6X5x7SfhVt8&language=en').catch(err => {
        this.$message.error('Network Error')
      })
      // console.log('created ok.')
      //this.initMap()

      // const promise2 = Promise.all([promise]).then(data => {
      //   console.log('google 加载完成', JSON.stringify(new Date()))
      // })
    }

    console.log('all data loaded start.')
    this.alldata = require(`@/views/home/data1.json`)
    this.allcontainers = require('@/views/home/container.json')
    this.fetchData()

    if (getToken() == '1') {
      this.currentSelectKey = ['1', '2', '3']
    } else {
      this.currentSelectKey = [getToken()]
    }

    // 获取数据开始

    // 加载谷歌地图、点聚合插件

    // 加载设备列表

    // 设置所有设备位置


    // 获取数据结束
  },
  mounted() {
    this.marker_red = require('../../assets/icon/CR.png')
    this.marker_orange = require('../../assets/icon/CO.png')
    this.marker_green = require('../../assets/icon/CG.png')
    this.marker_red_d = require('../../assets/icon/DR.png')
    this.marker_orange_d = require('../../assets/icon/DO.png')
    this.marker_green_d = require('../../assets/icon/DG.png')
    console.log('mounted ok.')
  },
  components: {
    AsideTab,
    AsideList,
    mapToolConfig,
    tree,
    Charts,
    Alarm
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/mixin.scss";
  .i-body {
    height: calc(100vh - 60px);
    flex-grow: 1;
    .i-side {
      border-right: 1px solid #DCDFE6;
      .i-aside-pane {
        box-sizing: border-box;
        height: 100%;
        overflow: auto;
        border: 1px solid #DCDFE6;
        border-top: none;
        //border-radius: 4px;
      }
      .typeline {
        // 状态类型
        justify-content: space-around;
        & > div {
          font-size: 12px;
          font-weight: 500;
          margin-top: 8px;
          margin-bottom: 8px;
          cursor: pointer;
          &:hover,&.active {
            text-decoration: underline;
          }
        }
      }
    }
    .i-main {
      padding: 0;
      height: auto;
      .i-pane-wrapper{
        overflow: hidden;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }
      .i-pane {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        &.chart {
          overflow-y: auto;
          background-color: #FAFAFA;
          @include scroll-bar;
        }
      }
      .i-pane-map {
        overflow: hidden;
      }
      .i-pane-alarm {
        top: auto;
        left: 20px;
        bottom: 0;
        z-index: 100;
        width: calc(100% - 40px);
        max-height: 300px;
        background-color: #fff;
        border-top: 1px solid #DCDFE6;
        overflow: visible;
        transition: all 0.3s ease;
        &-btn {
          border: 1px solid #DCDFE6;
          background-color: #fff;
          position: absolute;
          left: 50%;
          transform: translateY(-100%) translateX(-50%);
          text-align: center;
          line-height: 30px;
          height: 30px;
          cursor: pointer;
          z-index: 100;
          width: 80px;
        }
      }
    }
    .i-footer {
      //background-color: #B3C0D1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/home_20180613.vue